import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { googleReviews } from '../components/GoogleReviews';

const teamMembers = [
  {
    name: 'H Rafiudin Firdaus',
    title: 'Direktur',
    image: 'assets/img/H-Rafiudin-Firdaus.png',
  },
  {
    name: 'Suci Ardian Nufus',
    title: 'General Manager',
    image: 'assets/img/suci-3-300x300.jpg',
  },
  {
    name: 'Nadia Mela Kurnia',
    title: 'Finance',
    image: 'assets/img/Melaa-3-300x300.jpg',
  },
  {
    name: 'Rifqi Roushan Fikry',
    title: 'Manager Marketing',
    image: 'assets/img/rifqii-300x300.jpg',
  },
  {
    name: 'Anggi Ramdania H',
    title: 'Promosi',
    image: 'assets/img/Anggi-300x300.jpg',
  },
  {
    name: 'Rizqi Nurmuhaemin',
    title: 'Head of Sales',
    image: 'assets/img/rizki-300x300.jpg',
  },
  {
    name: 'Eka Susanti',
    title: 'Admin Marketing',
    image: 'assets/img/Ekaaas-300x300.jpg',
  },
  {
    name: 'Ashroniyah Fella Nasution',
    title: 'Administrasi',
    image: 'assets/img/Fella-300x300.jpg',
  },
  {
    name: 'Dede Indra Lesmana',
    title: 'Video Editor',
    image: 'assets/img/Dede-Indra-300x300.jpg',
  },
  {
    name: 'Muhammad Aldi Kurniawan',
    title: 'Design Grafis',
    image: 'assets/img/Alday-300x300.jpg',
  },
  {
    name: 'Dede Mulyana',
    title: 'Staff Operasional',
    image: 'assets/img/DEDEM-300x300.jpg',
  },
  {
    name: 'Ikhsan',
    title: 'Staff Operasional',
    image: 'assets/img/Isan-300x300.jpg',
  },
];

const feedData = [
  {
    username: 'sanematour',
    image: './assets/img/galeri-1.jpeg',
    caption: 'Momen haru saat pelepasan Jamaah Haji bersama keluarga tercinta.',
  },
  {
    username: 'sanematour',
    image: './assets/img/galeri-2.jpeg',
    caption: 'Kebersamaan Jamaah Sanema saat ziarah di Madinah Al-Munawwarah.',
  },
  {
    username: 'sanematour',
    image: './assets/img/galeri-3.jpeg',
    caption: 'Alhamdulillah, sampai di Tanah Suci. Doakan kami ya!',
  },
  {
    username: 'sanematour',
    image: './assets/img/galeri-4.jpeg',
    caption: 'Semangat menunaikan Umroh pertama bersama Sanema Tour.',
  },
  {
    username: 'sanematour',
    image: './assets/img/galeri-5.jpeg',
    caption: 'Thawaf di Baitullah, pengalaman yang tak terlupakan.',
  },
  {
    username: 'sanematour',
    image: './assets/img/galeri-6.JPG',
    caption: 'Belajar manasik Umroh sebelum keberangkatan.',
  },
  {
    username: 'sanematour',
    image: './assets/img/galeri-7.JPG',
    caption: 'Kebersamaan dalam ibadah, penuh makna dan kehangatan.',
  },
  {
    username: 'sanematour',
    image: './assets/img/galeri-8.JPG',
    caption: 'Momen penuh berkah bersama Jamaah Sanema.',
  },
  {
    username: 'sanematour',
    image: './assets/img/galeri-9.JPG',
    caption: 'Terima kasih Sanema Tour, perjalanan Umroh kami sangat nyaman.',
  },
  {
    username: 'sanematour',
    image: './assets/img/galeri-10.JPG',
    caption: 'Doa terbaik di Multazam. Semoga Allah kabulkan.',
  },
  {
    username: 'sanematour',
    image: './assets/img/galeri-11.JPG',
    caption: 'Santai setelah ibadah, bersama tim Sanema yang ramah.',
  },
  {
    username: 'sanematour',
    image: './assets/img/galeri-12.JPG',
    caption: 'Momen ziarah ke tempat bersejarah penuh hikmah.',
  },
  {
    username: 'sanematour',
    image: './assets/img/galeri-13.JPG',
    caption: 'Mengikuti manasik Umroh dengan bimbingan terbaik.',
  },
  {
    username: 'sanematour',
    image: './assets/img/galeri-14.JPG',
    caption: 'Antusiasme Jamaah saat berangkat dari Bandara Soekarno-Hatta.',
  },
  {
    username: 'sanematour',
    image: './assets/img/galeri-15.JPG',
    caption: 'Doa bersama sebelum berangkat menuju Mekkah.',
  },
  {
    username: 'sanematour',
    image: './assets/img/galeri-16.JPG',
    caption: 'Menjadi tamu Allah adalah karunia yang luar biasa.',
  },
  {
    username: 'sanematour',
    image: './assets/img/galeri-17.jpeg',
    caption: 'Keberangkatan Jamaah gelombang kedua bersama Sanema.',
  },
  {
    username: 'sanematour',
    image: './assets/img/galeri-18.jpeg',
    caption: 'Rindu suasana di Masjidil Haram. Semoga bisa kembali.',
  },
];

function About() {
  const [isReadMore, setIsReadMore] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [videoURL, setVideoURL] = useState('');
  const rows = [0, 1, 2]; // Untuk 3 baris

  const { ref: aboutRef, inView: aboutInView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  const extractVideoId = (url) => {
    const regExp =
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = url.match(regExp);
    return match ? match[1] : null;
  };

  const getYoutubeThumbnail = (url) => {
    const videoId = extractVideoId(url);
    return videoId
      ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`
      : '';
  };

  const openModal = (url) => {
    const videoId = extractVideoId(url);
    setVideoURL(`https://www.youtube.com/embed/${videoId}?autoplay=1`);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false); // Tutup modal
    setVideoURL(''); // Reset URL video saat modal ditutup
  };

  const youtubeLink = 'https://www.youtube.com/embed/1DXhdMWLtpo';

  const [activeKeyword, setActiveKeyword] = useState('Semua');

  const keywordsList = [
    'Semua',
    'pelayanan',
    'umroh & haji',
    'pengalaman',
    'makanan',
    'hotel',
    'city tour',
    'world tour',
  ];

  const filteredReviews =
    activeKeyword === 'Semua'
      ? googleReviews
      : googleReviews.filter((r) => r.keywords?.includes(activeKeyword));

  const averageRating =
    googleReviews.length > 0
      ? (
          googleReviews.reduce((sum, r) => sum + r.rating, 0) /
          googleReviews.length
        ).toFixed(1)
      : 0;

  const countByKeyword = (keyword) => {
    if (keyword === 'Semua') return googleReviews.length;
    return googleReviews.filter((r) => r.keywords?.includes(keyword)).length;
  };

  useEffect(() => {
    // Cek jika hash adalah '#testimoni'
    if (window.location.hash === '#testimoni') {
      const testimoniSection = document.getElementById('testimoni');
      if (testimoniSection) {
        testimoniSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []); // Efek dijalankan sekali ketika halaman dimuat

  return (
    <div>
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated fadeInUp">
                Tentang Kami
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Beranda</a>
                  </li>
                  {/* <li className="breadcrumb-item">
                <a href="/Pages">Pages</a>
              </li> */}
                  <li
                    className="breadcrumb-item text-white active"
                    aria-current="page"
                  >
                    About
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* About Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            <div
              className="col-lg-6 wow fadeInUp"
              data-wow-delay="0.1s"
              style={{ minHeight: 400 }}
            >
              <div className="video-wrapper">
                <div className="position-relative w-100 h-100">
                  {!isModalOpen ? (
                    <>
                      <img
                        className="img-fluid position-absolute w-100 h-100"
                        src={getYoutubeThumbnail(youtubeLink)}
                        alt="Thumbnail Video"
                        style={{ objectFit: 'cover', cursor: 'pointer' }}
                        onClick={() => openModal(youtubeLink)}
                      />
                      <div
                        className="video-play-btn"
                        onClick={() =>
                          openModal('https://www.youtube.com/embed/1DXhdMWLtpo')
                        }
                      >
                        <i className="fa fa-play" />
                      </div>
                      <div className="video-label-overlay">
                        <strong>Mengapa Harus Sanema Tour?</strong>
                      </div>
                    </>
                  ) : (
                    <iframe
                      className="position-absolute w-100 h-100"
                      src={videoURL}
                      title="YouTube video"
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                    ></iframe>
                  )}
                  {isModalOpen && (
                    <button
                      onClick={closeModal}
                      className="btn btn-danger position-absolute top-0 end-0 m-3"
                    >
                      &times;
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div
              className="col-lg-6 wow fadeInUp"
              data-wow-delay="0.3s"
              ref={aboutRef}
            >
              <h1 className="mb-4">
                <span
                  className={`sanema ${aboutInView ? 'glowing-text' : ''}`}
                  style={{ color: '#d7b04a' }}
                >
                  Sanema Tour
                </span>
                ,{' '}
                <span style={{ color: 'black' }}>
                  Berizin Resmi dan Menjadi Mitra Terpercaya untuk Perjalanan
                  Ibadah Anda
                </span>
              </h1>

              <p className="mb-4">
                <span className="stabilo1 sub-text">
                  Alhamdulillah, Sanema Tour adalah agen perjalanan Haji, Umroh,
                  dan Halal Tour yang telah beroperasi sejak tahun 2018. Dengan
                  pengalaman lebih dari 6 tahun, kami berkomitmen untuk terus
                  memberikan pelayanan terbaik bagi para tamu Allah.
                </span>
              </p>
              <p className="mb-4">
                <span className="stabilo1 sub-text">
                  Kami sangat memahami pentingnya perjalanan spiritual ini. Oleh
                  karena itu, Sanema Tour hadir untuk mendampingi setiap langkah
                  dalam safar mulia ini, memastikan bahwa setiap perjalanan
                  menjadi pengalaman yang penuh makna.
                </span>
              </p>
              <div className="row gy-2 gx-4 mb-4">
                <div className="col-sm-6">
                  <p className="mb-0 stabilo1 sub-text">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    Manasik di hotel
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0 stabilo1 sub-text">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    Audio visual saat manasik
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0 stabilo1 sub-text">
                    <i className="fa fa-arrow-right text-primary me-2" />5 Star
                    Umroh 1 - 3 kali
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0 stabilo1 sub-text">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    Majlis Ilmu in Haram
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0 stabilo1 sub-text">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    Qiamul Lail berjamaah
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0 stabilo1 sub-text">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    Thawaf sunnah
                  </p>
                </div>
                {/* Teks yang disembunyikan */}
                {isReadMore && (
                  <div className="col-sm-6">
                    <p className="mb-0 stabilo1 sub-text">
                      <i className="fa fa-arrow-right text-primary me-2" />
                      Ziaroh plus tadabbur siroh perjalanan dakwah Rasulullah
                    </p>
                  </div>
                )}
              </div>
              {/* Tombol untuk toggle Read More */}
              <button
                className="btn btn-primary py-3 px-5 mt-2"
                onClick={toggleReadMore}
              >
                {isReadMore ? 'Read Less' : 'Read More'}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* About End */}

      <div class="container py-5 wow fadeInUp">
        <div class="row justify-content-center text-center mb-4">
          <div class="col-lg-8">
            <h2 className="fw-bold">
              <span className="shine-text judul">Visi & Misi</span>{' '}
              <span className="glowing-text judul">Sanema Tour</span>
            </h2>

            <p class="text-architects sub-text">
              Tujuan dan langkah kami dalam mendampingi Anda menuju ibadah yang
              khusyuk dan bermakna.
            </p>
          </div>
        </div>
        <div class="row g-5">
          <div class="col-md-6">
            <div class="p-4 border rounded shadow-sm h-100 stabilo1">
              <h4 class="text-gold mb-3">
                <i class="fas fa-eye me-2 judul"></i>Visi
              </h4>
              <p class="mb-0 text-architects sub-text">
                Menjadi Mitra Terpercaya untuk Perjalanan Ibadah Anda
              </p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="p-4 border rounded shadow-sm h-100 stabilo2">
              <h4 class="text-gold mb-3">
                <i class="fas fa-bullseye me-2 judul"></i>Misi
              </h4>
              <ul class="list-unstyled mb-0 text-architects sub-text">
                <li class="mb-2">
                  <i class="fas fa-check-circle text-primary me-2"></i> Memberi
                  kepastian keberangkatan.
                </li>
                <li class="mb-2">
                  <i class="fas fa-check-circle text-primary me-2"></i> Membantu
                  merencanakan ibadah termasuk pembiayaanya.
                </li>
                <li class="mb-2">
                  <i class="fas fa-check-circle text-primary me-2"></i>{' '}
                  Memberikan akomodasi dan pelayanan terbaik sesuai dengan
                  paket.
                </li>
                <li class="mb-2">
                  <i class="fas fa-check-circle text-primary me-2"></i>{' '}
                  Memberikan program yang mudah untuk beribadah.
                </li>
                <li class="mb-2">
                  <i class="fas fa-check-circle text-primary me-2"></i>{' '}
                  Memberikan pendidikan dan pelatihan dalam pengembangan bisnis
                  untuk mewujudkan niat ibadah dan kesejahteraan.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <section className="clients py-5">
        <div className="container wow fadeInUp">
          <h2
            className="text-center mb-4 fw-bold judul"
            style={{ color: 'black', zIndex: 2, position: 'relative' }}
          >
            Berizin Resmi dan Tersertifikasi
          </h2>
          <Swiper
            slidesPerView={3}
            spaceBetween={30}
            loop={true}
            autoplay={{ delay: 1500, disableOnInteraction: false }}
            breakpoints={{
              576: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              992: { slidesPerView: 4 },
            }}
            modules={[Autoplay]}
            className="clients-slider"
          >
            {[
              'asita-logo-300x216.png',
              'attmi.webp',
              'bersathu-logo-300x225.png',
              'ias.jfif',
              'kan.png',
              'bnsp.png',
              'logo-kadin-300x300.png',
              'logo-kemenag-150x150.webp',
              'siskopatuh-logo-150x150.webp',
              '5-pasti-umroh-logo-150x150.png',
            ].map((logo, idx) => (
              <SwiperSlide className="slide" key={idx}>
                <img src={`./assets/img/${logo}`} alt={`Logo ${idx + 1}`} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      {/* Team Start */}
      <div className="container-xxl py-5">
        <div className="container wow fadeInUp">
          <div className="text-center mb-5">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Tim Kami
            </h6>
            <h2 className="fw-bold mt-3 text-dark sub-text">
              <span className="shine-text">Profesional dan Berpengalaman</span>{' '}
              untuk Perjalanan Ibadah Anda
            </h2>
            <p
              className="mt-3 stabilo2 sub-text"
              style={{
                maxWidth: '800px',
                margin: '0 auto',
                color: '#555',
                fontSize: '1.15rem',
              }}
            >
              Tim kami terdiri dari para profesional yang berdedikasi untuk
              memastikan setiap perjalanan ibadah Anda berjalan dengan lancar.
              Dengan pengalaman bertahun-tahun di industri perjalanan Umroh dan
              Haji, kami memahami kebutuhan dan harapan jamaah. Kami berkomitmen
              untuk memberikan yang terbaik di setiap langkah perjalanan Anda,
              dari awal hingga akhir.
            </p>
          </div>

          <Swiper
            slidesPerView={1}
            spaceBetween={20}
            loop={true}
            autoplay={{ delay: 800, disableOnInteraction: false }}
            breakpoints={{
              576: { slidesPerView: 1 },
              768: { slidesPerView: 3 },
              992: { slidesPerView: 4 },
            }}
            modules={[Autoplay]}
          >
            {teamMembers.map((member, idx) => (
              <SwiperSlide key={idx}>
                <div className="team-item">
                  <div className="overflow-hidden stabilo2">
                    <img
                      className="img-fluid"
                      src={member.image}
                      alt={member.name}
                    />
                  </div>
                  <div
                    className="position-relative d-flex justify-content-center"
                    style={{ marginTop: '-19px' }}
                  >
                    <a className="btn btn-square mx-1" href="">
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a className="btn btn-square mx-1" href="">
                      <i className="fab fa-twitter" />
                    </a>
                    <a className="btn btn-square mx-1" href="">
                      <i className="fab fa-instagram" />
                    </a>
                  </div>
                  <div className="text-center p-4 stabilo2">
                    <h5 className="mb-0" style={{ color: 'black' }}>
                      {member.name}
                    </h5>
                    <small style={{ color: 'black' }}>{member.title}</small>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      {/* Team End */}

      <section className="container-xxl py-5">
        <div className="container wow fadeInUp">
          <div className="text-center mb-5">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Galeri & Cerita Para Jamaah
            </h6>
          </div>

          {rows.map((rowIndex) => (
            <Swiper
              key={rowIndex}
              slidesPerView={3}
              spaceBetween={20}
              loop={true}
              autoplay={{ delay: 2500, disableOnInteraction: false }}
              modules={[Autoplay]}
              className="mb-4"
              breakpoints={{
                0: { slidesPerView: 1 },
                576: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                992: { slidesPerView: 3 },
                1200: { slidesPerView: 3 },
              }}
            >
              {feedData
                .slice(rowIndex * 6, (rowIndex + 1) * 6)
                .map((item, idx) => (
                  <SwiperSlide key={idx}>
                    <div className="ig-card shadow-sm h-100">
                      <div className="ig-header stabilo1">
                        <img
                          src="./assets/img/sanema-logo.ico"
                          alt="Sanema Logo"
                          className="ig-avatar"
                        />
                        <strong className="ms-2">{item.username}</strong>
                      </div>
                      <img
                        src={item.image}
                        alt="Instagram Feed"
                        className="ig-image"
                      />
                      <div className="ig-caption stabilo1">
                        <p className="mb-0">{item.caption}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
            </Swiper>
          ))}
        </div>
      </section>

      <section className="py-5 wow fadeInUp" id="testimoni">
        <div className="container">
          <div className="text-center mb-4">
            <h6 className="section-title bg-white text-center text-primary px-3 fs-3 fw-bold">
              Testimoni
            </h6>
            <p className="text-muted">
              Rating rata-rata: <strong>{averageRating} / 5</strong> ⭐
            </p>
            <div className="mb-4">
              {keywordsList.map((key) => (
                <button
                  key={key}
                  className={`btn btn-sm m-1 ${
                    activeKeyword === key
                      ? 'btn-primary'
                      : 'btn-outline-primary'
                  }`}
                  onClick={() => setActiveKeyword(key)}
                >
                  {key} ({countByKeyword(key)})
                </button>
              ))}
            </div>
          </div>
          <Swiper
            modules={[Autoplay]}
            autoplay={{ delay: 4000 }}
            loop={true}
            spaceBetween={30}
            slidesPerView={1}
            breakpoints={{
              576: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
            }}
          >
            {filteredReviews.map((review, idx) => (
              <SwiperSlide key={idx}>
                <div className="card shadow border-0 p-4 h-100 position-relative stabilo2">
                  <div className="position-absolute top-0 start-0 m-3 fs-1 text-warning">
                    “
                  </div>
                  <blockquote className="blockquote mt-4 mb-0">
                    <p
                      className="mb-4 text-muted sub-text"
                      style={{ fontStyle: 'italic' }}
                    >
                      {review.text}
                    </p>
                    <footer className="blockquote-footer">
                      <strong>{review.author}</strong> -{' '}
                      <span className="text-secondary">{review.role}</span>
                      <div className="text-warning mt-2">
                        {'★'.repeat(review.rating)}
                        {'☆'.repeat(5 - review.rating)}
                      </div>
                    </footer>
                  </blockquote>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
    </div>
  );
}

export default About;
